<app-form-custrights
    [result]="selectedResult"
    [groupList]="groupList"
    [userList]="userList"
    [screenList]="screenList"
    (onValidate)="validate($event)"
    (onCancel)="cancel($event)"
    (onDelete)="delete($event)"
>
</app-form-custrights>

